<template>
    <div>
        <b-row>
            <b-col>
                <h1>{{ $t('mip.faq.title') }}</h1>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col class="col-md-12 faqCard">
                <b-list-group class="faq">
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.collapseMobilityInsightsData>
                            <span v-html="$t('mip.faq.mobiliytInsightsDataQuestion')"></span>
                        </h4>
                        <b-collapse id="collapseMobilityInsightsData">
                            <p class="accordion-text" v-html="$t('mip.faq.mobilityInsightsData')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.collapseSwisscomOnly>
                            {{ $t('mip.faq.onlySwisscomQuestion') }}
                        </h4>
                        <b-collapse id="collapseSwisscomOnly">
                            <p class="accordion-text" v-html="$t('mip.faq.onlySwisscom')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.dataProtection>
                            {{ $t('mip.faq.dataProtectionQuestion') }}
                        </h4>
                        <b-collapse id="dataProtection">
                            <p class="accordion-text" v-html="$t('mip.faq.dataProtection')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.dataComputation>
                            {{ $t('mip.faq.dataComputationQuestion') }}
                        </h4>
                        <b-collapse id="dataComputation">
                            <p class="accordion-text" v-html="$t('mip.faq.dataComputation')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.simAttribution>
                            {{ $t('mip.faq.simAttributionQuestion') }}
                        </h4>
                        <b-collapse id="simAttribution">
                            <p class="accordion-text" v-html="$t('mip.faq.simAttribution')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.recomputation>
                            {{ $t('mip.faq.recomputationQuestion') }}
                        </h4>
                        <b-collapse id="recomputation">
                            <p class="accordion-text" v-html="$t('mip.faq.recomputation')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.MobilityInsightsComputedData>
                            {{ $t('mip.faq.MobilityInsightsComputedDataQuestion') }}
                        </h4>
                        <b-collapse id="MobilityInsightsComputedData">
                            <p class="accordion-text" v-html="$t('mip.faq.MobilityInsightsComputedData')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.provenanceTotal>
                            {{ $t('mip.faq.provenanceTotalQuestion') }}
                        </h4>
                        <b-collapse id="provenanceTotal">
                            <p class="accordion-text" v-html="$t('mip.faq.provenanceTotal')"></p>
                        </b-collapse>
                    </b-list-group-item>
                    <b-list-group-item>
                        <h4 class="accordion" v-b-toggle.limitsDefinitionTerritory>
                            {{ $t('mip.faq.limitsDefinitionTerritoryQuestion') }}
                        </h4>
                        <b-collapse id="limitsDefinitionTerritory">
                            <p class="accordion-text" v-html="$t('mip.faq.limitsDefinitionTerritory')"></p>
                        </b-collapse>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
}
</script>

<style lang="scss" >
.accordion-text {
    border-top: 1px solid #e9ecef;
    margin-top: 0.5rem;
    padding-top: 1rem;
    margin-bottom: 0.5rem;
    color: rgb(0, 0, 0);

    br {
        display: block;
        content: "";
        margin-top: 10px;
    }

}

.accordion:after {
    content: "+";
    width: 30px;
    height: 30px;
    background-color: transparent;
    top: 10px;
    right: 5px;
    position: absolute;
    display: inline-block;
}

.accordion:not(.collapsed):after {
    content: "-";
}

.list-group-item:last-child {
    border-bottom-left-radius: calc(0.5rem - 1px) !important;
    border-bottom-right-radius: calc(0.5rem - 1px) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.list-group-item:first-child {
    border-top-left-radius: calc(0.5rem - 1px) !important;
    border-top-right-radius: calc(0.5rem - 1px) !important;
    border-top: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.list-group:not(.list-group-sortable) .list-group-item {
    border-radius: 0;
    border-left: solid 1px rgba(0, 0, 0, 0.125) !important;
    border-right: solid 1px rgba(0, 0, 0, 0.125) !important;
}

.list-group-item ol {
    list-style: decimal !important;
    padding-left: 3rem !important;
}

.list-group-item ul {
    list-style: disc !important;
    padding-left: 3rem !important;
}
</style>